export const LEFT_US_TITLE = 'Left us:';
export const ON_THE_WAY_WITH_TITLE = 'On the way with ';
export const ARRIVED_WITH_YOU_TITLE = 'Arrived with you';
export const COURIER_TO_BE_CONFIRMED = 'Courier to be confirmed';
export const EXPECTED_DELIVERY_TITLE = 'Expected delivery';
